module.exports = __webpack_public_path__ + "8308162eed8e9af997a63f685a258345.gif";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/main/status-active.gif
// module id = 180
// module chunks = 0